"use client";

import React, { useState } from "react";

import { submitContactForm } from "@/app/actions/contact";
import { ContactConsultantReference } from "@/types";

import {
	ContactFormValues,
	ContactYourConsultant
} from "@/composites/consultant";

type ContactConsultantProps = Omit<ContactConsultantReference, "siteKey"> & {
	captchaSiteKey: string;
};

/**
 * ContactConsultant block component — wires the `ContactYourConsultant`
 * modal form to the `submitContactForm` server action.
 */
export function ContactConsultant(props: ContactConsultantProps): JSX.Element {
	const [isSubmitted, setIsSubmitted] = useState(false);

	/**
	 * Submit contact request using Server Action
	 * @param values [ContactFormValues]
	 */
	async function handleFormSubmit(values: ContactFormValues): Promise<void> {
		try {
			await submitContactForm(values);
			setIsSubmitted(true);
		} catch (error) {
			// TODO: handle error logging or error state
			// eslint-disable-next-line no-console
			console.error("Error submitting form", error);
		}
	}

	return (
		<ContactYourConsultant
			triggerElement={props.triggerElement as React.ReactNode}
			consultant={{
				consultantNumber: props.consultant?.consultantNumber,
				image: props.consultant?.image,
				name: props.consultant?.name,
				location: props.consultant?.location
			}}
			closeButtonLabel={props.closeButtonLabel}
			thankYouMessage={{
				title: props.thankYouMessage?.title,
				description: props.thankYouMessage?.description
			}}
			isSubmitted={isSubmitted}
			onSubmit={handleFormSubmit}
			siteKey={props.captchaSiteKey}
			isOpen={props.openByDefault}
			onClose={props.onClose}
		/>
	);
}
